import { render, staticRenderFns } from "./BusinessDisputes.vue?vue&type=template&id=733026d0"
import script from "./BusinessDisputes.vue?vue&type=script&lang=js"
export * from "./BusinessDisputes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports